import {ListItem, ListItemButton, ListItemIcon, ListItemText, SvgIcon,} from "@mui/material";

import {useNavigate} from "react-router-dom";
import React from "react";
import LightGreyTooltip from "../../../../global/components/Tooltip/Tooltip";

interface IProps {
    text: string;
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    index: number;
    open: boolean;
    path: string;
}

const NavItem: React.FC<IProps> = ({
                                       text,
                                       open,
                                       icon,
                                       path,
                                   }): JSX.Element => {
    const navigate = useNavigate();

    return (

        <LightGreyTooltip title={text} arrow={true} placement={"right"}>

    <ListItem
        key={text}
        disablePadding
        sx={{display: "block"}}
        onClick={() => navigate(path)}
    >
        <ListItemButton
            sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
            }}
        >
            <ListItemIcon
                sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                }}
            >
                <SvgIcon color={"primary"} component={icon} inheritViewBox/>
            </ListItemIcon>
            <ListItemText primary={text} sx={{opacity: open ? 1 : 0}}/>
        </ListItemButton>
    </ListItem>
</LightGreyTooltip>


)
    ;
};

export default NavItem;
